import { render } from "./WuCaiGouFuKuanDetail.vue?vue&type=template&id=b7d91d6c"
import script from "./WuCaiGouFuKuanDetail.vue?vue&type=script&lang=js"
export * from "./WuCaiGouFuKuanDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__